export default "__VITE_ASSET__c48ff1fe__"